<template>
<div class="setting-header">
        <span>{{ title }}</span>
        <a-trigger trigger="hover" position="br" :unmount-on-close="false" :popup-translate="[0, 8]" v-if="showtype !== 'sdk'">
            <div v-if="!isInToca" class="file-avatar-img" id="avatar-img">
                <div v-if="userAvatar === ''" class="user-avatar" :style="avatarColorStye()">
                    <div class="user-name">{{ userName() }}</div>
                </div>
                <img v-else :src="userAvatar" style="object-fit: cover"/>
            </div>
            <template #content>
                <div class="user-info-card">
                    <div class="info-header">
                        <div v-if="userAvatar === ''" class="user-avatar" :style="avatarColorStye()">
                            <div class="user-name">{{ userName() }}</div>
                        </div>
                        <img v-else :src="userAvatar"/>
                        <div class="user-info">
                            <div class="user-name">
                                {{ this.currentUserInfo?.memberName }}
                            </div>
                            <div class="user-department">
                                {{ userDepartment }}
                            </div>
                        </div>
                    </div>
                    <div class="logout-btn" @click="handlerLogout">
                        <img src="@/assets/img/setting/icon_setting_logout.svg"/>{{$t("退出登录")}}                    </div>
                </div>
            </template>
        </a-trigger>
    </div>
</template>

<script lang="ts">
import nameColor from '../../utils/nameColor';
import memberAvatar from '../../utils/avatar';
import { gethUserInfo } from '../../core/api/setting';

import { mapState } from 'vuex';
import { clearCookieAndToLogin } from '../../login';
import { getBrowser } from '../../utils/browser';
import { logoutUtil } from '@/utils/logoutUtil';

export default {
    name: 'SettingHeaderView',
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            currentUserInfo: null,
            userAvatar: '',
            userDepartment: ''
        };
    },
    created() {
        this.queryCurrentUserInfo();
    },
    computed: {
        ...mapState({
            userId: (state: any) => state.userModule.userId,
            spaceId: (state: any) => state.userModule.spaceId,
            showtype: (state: any) => state.kbModule.showtype
        }),
        isInToca() {
            return getBrowser().isInTocaApp;
        },
        userInfo() {
            return {
                spaceId: this.spaceId,
                userId: this.userId
            };
        }
    },
    methods: {
        queryCurrentUserInfo() {
            gethUserInfo(this.userInfo)
                .then((res: any) => {
                    const { code, data, message } = res.data;
                    if (code === 200) {
                        this.currentUserInfo = data;
                        const avatar: string = this.currentUserInfo
                            ?.memberAvatar;
                        const userAvatar = memberAvatar.getMemberAvatar(
                            avatar,
                            ''
                        );
                        this.userAvatar =
                            userAvatar['100'] ??
                            userAvatar['300'] ??
                            userAvatar['original'];
                        this.userDepartment = this.currentUserInfo.departments
                            ?.map((item: any) => item.departmentName)
                            .join('/');
                    }
                })
                .catch();
        },
        avatarColorStye() {
            const memberName: string = this.currentUserInfo?.memberName;
            if (!memberName) {
                return 'display: none;';
            }
            let avatarColor = nameColor.getNameColor(memberName);
            return `background-color: ${avatarColor}`;
        },
        userName() {
            const memberName: string = this.currentUserInfo?.memberName;
            return nameColor.getLastName(memberName);
        },
        handlerLogout() {
            logoutUtil((isLogout: boolean) => {
                clearCookieAndToLogin(isLogout);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.setting-header {
    height: 54px;
    background-color: #ffffff;
    box-shadow: inset 0 -1px 0 0 #e2e6ed;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    padding: 0 16px 0 24px;

    span {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #121317;
        letter-spacing: 0;
        line-height: 22px;
    }

    .file-avatar-img {
        width: 26px;
        height: 26px;
        border-radius: 4px;
        position: absolute;
        right: 16px;

        img {
            width: 26px;
            height: 26px;
            border-radius: 4px;
        }

        .user-avatar {
            width: 26px;
            height: 26px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            .user-name {
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 9px;
                color: #ffffff;
                line-height: 26px;
                letter-spacing: 0;
            }
        }
    }
}
.user-info-card {
    width: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;

    .info-header {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        width: 248px;
        margin-top: 16px;

        .user-avatar {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            .user-name {
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 9px;
                color: #ffffff;
                line-height: 26px;
                letter-spacing: 0;
            }
        }

        img {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            flex-shrink: 0;
        }

        .user-info {
            margin-left: 14px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;

            .user-name {
                margin-bottom: 7px;
                font-weight: 600;
                font-size: 17px;
                color: #121317;
                line-height: 24px;
            }

            .user-department {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                color: #646573;
                line-height: 17px;
            }
        }
    }

    .logout-btn {
        margin: 16px;
        width: 248px;
        height: 44px;
        background: #f4f6f9;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #222329;
        line-height: 20px;
        cursor: pointer;

        img {
            margin: 0 8px;
            width: 20px;
            height: 20px;
        }
    }
}
</style>
